import React from 'react'
import ShowChartIcon from '@material-ui/icons/ShowChartOutlined'
import { createColumnInstance } from '../../constants'

const PERFORMANCE = createColumnInstance('performance')
const BENCHMARK = createColumnInstance('benchmarkPerformance')

export const performanceVsBenchmark = Object.freeze({
  id: 'performance-vs-benchmark',
  name: 'Performance vs Benchmark',
  description: 'Performance overlaid with the household benchmark over time.',
  renderIcon: () => <ShowChartIcon style={{ fontSize: 16 }} />,
  toolId: 'trend',
  resolve: () => ({
    ok: true,
    payload: {
      scope: 'level',
      columnInstance: PERFORMANCE,
      compareColumns: [BENCHMARK],
      chartType: 'line',
      frequency: 'Automatic'
    }
  })
})
